// ** React Imports
import { useEffect, useCallback, useRef, useState } from 'react'

// ** Next Imports
// import Link from 'next/link'
// import { useRouter } from 'next/router'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import MuiDialog from '@mui/material/Dialog'
import ListItem from '@mui/material/ListItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import useMediaQuery from '@mui/material/useMediaQuery'
import { styled, useTheme } from '@mui/material/styles'
import ListItemButton from '@mui/material/ListItemButton'
import InputAdornment from '@mui/material/InputAdornment'

// ** Third Party Imports
import axios from 'axios'

// ** Icon Imports
import Icon from './icon'

// ** Configs Imports
import themeConfig from '../../configs/themeConfig'
import { Button, Chip, Divider } from '@mui/material'
import { updateExpectedDeliveryDateNumberFormat } from '../../component/functions/unitoistDateFormate'
import { isoToSortDate } from '../../component/functions/isoToSortDate'
import { userData } from '../../hooks/userData'
import { copyToAutofill } from '../../component/ui/chat/copyToAutofill'
import { useSmartClaim } from '../../hooks/smartClaim'
import { showSnackbar } from '../../component/ui/toast/snackbarService'

// ** Styled Dialog component
const Dialog = styled(MuiDialog)({
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(4px)'
  },
  '& .MuiDialog-paper': {
    overflow: 'hidden',
    '&:not(.MuiDialog-paperFullScreen)': {
      height: '100%',
      maxHeight: 550
    }
  }
})

const DefaultSuggestions = ({ setOpenDialog }) => {
  return (
    <Grid container spacing={6} sx={{ ml: 0 }}>
      <Typography>Find By Order Id </Typography>
    </Grid>
  )
}

const commonTypographyStyles = {
  fontSize: { xs: "11px", sm: "12px", md: "12.5px", lg: "13px" }, // Responsive font sizes
  display: "flex",
  alignItems: "center",
  mb: 0.3
};

const highlightedText = {
  letterSpacing: "0.5px",
  marginLeft: "5px",
  fontSize: "inherit",
};
const AutocompleteComponent = ({ hidden, settings }) => {
  // ** States
  const [isMounted, setIsMounted] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [openDialog, setOpenDialog] = useState(false)
  const [subOrederList, setSubOrederList] = useState([])
  const [noValueFound, setNoValueFound] = useState('')
  const [userDetails, setUserDetails] = useState({})
  const [ticket, setTicket] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  // ** Hooks & Vars
  const theme = useTheme()
  const gstList = userData();
  const sc_claim = useSmartClaim();

  // const router = useRouter()
  const { layout } = settings
  const wrapper = useRef(null)
  const fullScreenDialog = useMediaQuery(theme.breakpoints.down('sm'))

  const fetchRecord = (params, token) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/order/list`, params, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        if (response.data.page.totalElements > 0) {
          setSubOrederList(response.data._embedded.meeshoOrderList)
          const findUserDerails = gstList.user.find((item) => item.id === response.data._embedded.meeshoOrderList[0].id.gstProfileId)
          setUserDetails({
            platformemail: findUserDerails.platformEmail,
            truesellerEmail: findUserDerails.user.email,
            companyName: findUserDerails.companyName,
          })
        } else {
          setNoValueFound(params.search)
        }
      })
      .catch(err => {
        console.log('err', err)
      })
  }

  const handleSearchSubmit = () => {
    let token = JSON.parse(localStorage.getItem("userData"))
    if (searchValue.trim() && token) {
      const payload = {
        "searchBy": "order_id",
        "search": searchValue
      }
      fetchRecord(payload, token)
    }
  };

  const handleAutoFill = (orderData) => {
    let downloadData;
    let heading;
    if (orderData.smartClaims[0].returnTypes === 'CUSTOMER_RETURN') {
      downloadData = ["reverseWaybill", "barcodeImage", "productImage", "unpackingVideo", 'attachment']
      heading = 'I have received wrong return'
    } else if (orderData.smartClaims[0].returnTypes === 'RTO_RETURN') {
      downloadData = ["reverseWaybill", "productImage", "unpackingVideo", 'attachment']
      heading = 'I have received a wrong barcoded package in RTO'
    } else if (orderData.smartClaims[0].returnTypes === 'NON_BARCODED_RTO') {
      downloadData = ["reverseWaybill", "productImage", "unpackingVideo", 'attachment']
      heading = 'I have received an RTO in a non-barcoded package'
    } else if (orderData.smartClaims[0].returnTypes === 'Damage') {
      downloadData = ["reverseWaybill", "barcodeImage", "productImage", "unpackingVideo", 'attachment']
      heading = 'I have received damaged return'
    } else if (orderData.smartClaims[0].returnTypes === 'MISSING_QTY') {
      downloadData = ["reverseWaybill", "barcodeImage", "productImage", "unpackingVideo", 'attachment']
      heading = 'Item/s are missing in my return'
    } else if (orderData.smartClaims[0].returnTypes === 'USED_RETURN') {
      downloadData = ["reverseWaybill", "barcodeImage", "productImage", "unpackingVideo", 'attachment']
      heading = 'I have received used product as return'
    }
    copyToAutofill(orderData.smartClaims[0], orderData.smartClaims[0].returnTypes, 'COMPLETED', downloadData, heading, 'Autofill')
  }

  const handleSubmitRequest = (record, index) => {
    if (!ticket) {
      showSnackbar("Ticket Id Required", "error");
    } else {
      setIsLoading(true)
      let payload = {
        id: record.id,
        ticketId: ticket,
        gstProfileId: record.gstProfileId,
        description: record.description,
      };
      if (record.statusOfClaim === "PENDING") {
        payload["statusOfClaim"] = "COMPLETED";
      }
      if (record.statusOfClaim === "CLAIM_NOT_SUBMITTED") {
        payload["statusOfClaim"] = "COMPLETED";
      }
      sc_claim.postClaimSubmit(payload, (response) => {
        if (response.status === "success") {
          setTicket('');
          setIsLoading(false)
          showSnackbar("Record Submitted successfully!", "success");
        } else {
          showSnackbar("Something Went Wrong", "error");
        }
      });
    }
  };

  const handleFailRequest = (record, index) => {
    setIsLoading(true)
    let payload = {
      id: record.id,
      gstProfileId: record.gstProfileId,
      description: record.description,
    };
    if (record.statusOfClaim === "COMPLETED" || record.statusOfClaim === "PENDING") {
      payload["statusOfClaim"] = "CLAIM_NOT_SUBMITTED";
    }

    sc_claim.postClaimSubmit(payload, (response) => {
      if (response.status === "success") {
        setTicket('');
        setIsLoading(false)
        showSnackbar("Record Submitted successfully!", "success");
      } else {
        showSnackbar("Something Went Wrong", "error");
      }
    });

  }
  useEffect(() => {
    if (!openDialog) {
      setSearchValue('')
    }
  }, [openDialog])
  useEffect(() => {
    setIsMounted(true)

    return () => setIsMounted(false)
  }, [])

  // Handle click event on a list item in search result

  useEffect(() => {
    if (openDialog) {
      setSubOrederList([])
    }
  }, [openDialog])

  // Handle ESC & shortcut keys keydown events
  const handleKeydown = useCallback(
    event => {
      // ** Shortcut keys to open searchbox (Ctrl + /)
      if (!openDialog && event.ctrlKey && event.which === 191) {
        setOpenDialog(true)
      }
    },
    [openDialog]
  )

  // Handle shortcut keys keyup events
  const handleKeyUp = useCallback(
    event => {
      // ** ESC key to close searchbox
      if (openDialog && event.keyCode === 27) {
        setOpenDialog(false)
      }
    },
    [openDialog]
  )
  useEffect(() => {
    document.addEventListener('keydown', handleKeydown)
    document.addEventListener('keyup', handleKeyUp)

    return () => {
      document.removeEventListener('keydown', handleKeydown)
      document.removeEventListener('keyup', handleKeyUp)
    }
  }, [handleKeyUp, handleKeydown])

  const handleSearchValue = (event) => {
    if (event.target.value.length === 0) {
      setSubOrederList([])
    }
    setSearchValue(event.target.value)
  }

  const formatDate = (isoString) => {
    const date = new Date(isoString);

    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "2-digit",
      year: "numeric",
    });
  };

  if (!isMounted) {
    return null
  } else {
    return (
      <Box
        ref={wrapper}
        onClick={() => !openDialog && setOpenDialog(true)}
        sx={{ display: 'flex', cursor: 'pointer', alignItems: 'center', padding: "5px 40px", backgroundColor: "#e6e5e7", borderRadius: '10px', height: "35px" }}
      >
        <IconButton color='inherit' sx={!hidden && layout === 'vertical' ? { mr: 0.5, ml: -2.75 } : {}}>
          <Icon icon='tabler:search' fontSize='22px' />
        </IconButton>
        {!hidden && layout === 'vertical' ? (
          <Typography sx={{ userSelect: 'none', color: 'text.disabled' }}>Search (Ctrl+/)</Typography>
        ) : null}
        {openDialog && (
          <Dialog fullWidth open={openDialog} fullScreen={fullScreenDialog} onClose={() => setOpenDialog(false)} PaperProps={{
            sx: {
              maxWidth: "1500px", // Set maximum width
              width: "100%", // Ensures responsiveness
              marginLeft: "auto",
              marginRight: "auto",
            }
          }}>
            <Box sx={{ top: 0, width: '100%', position: 'sticky', height: "50px" }}>
              <TextField
                variant="standard"
                sx={{
                  width: "100%",
                  '& .MuiInput-underline:before': { // Set fixed bottom border before focus
                    borderBottom: '1px solid #00000029 !important',
                  },
                  '& .MuiInput-underline:after': { // Ensure the border remains after focus
                    borderBottom: '2px solid #00000029 !important',
                  },
                  '& .MuiInputBase-root.MuiInput-root': {
                    height: '50px',
                    padding: "0 10px"

                  },
                }}
                value={searchValue}
                onChange={handleSearchValue}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    handleSearchSubmit();
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon fontSize='1.5rem' icon='tabler:search' />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        variant="contained"
                        style={{ marginRight: '10px', fontSize: '12px', padding: '10px 15px' }}
                        onClick={handleSearchSubmit}
                      >
                        Submit
                      </Button>
                      <IconButton size="small" sx={{ p: 1 }} onClick={() => setOpenDialog(false)}>
                        <Icon icon="tabler:x" fontSize="1.25rem" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            {subOrederList.length === 0 ? (
              <Box
                sx={{
                  p: 10,
                  display: 'grid',
                  overflow: 'auto',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderTop: `1px solid ${theme.palette.divider}`,
                  height: fullScreenDialog ? 'calc(100vh - 69px)' : '100%'
                }}
              >
                <DefaultSuggestions setOpenDialog={setOpenDialog} />
              </Box>
            ) : null}
            {searchValue.length !== 0 && subOrederList.length !== 0 ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  background: "#8080801f",
                  p: 2,
                  height: '100%',
                  overflowY: "auto"
                }}
              >
                <Box className='chat-body' style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                  <Grid item xs={12}>
                    {subOrederList.map((order, index) => {
                      return (<Box display="flex" justifyContent="center" mb={2} sx={{ background: "white", px: 2 }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Box sx={{ background: "#fff5dc", mt: 2, p: 1 }}>
                              <Typography sx={{ ...commonTypographyStyles, color: "#d18b1f", fontWeight: 600 }}>
                                {userDetails.companyName}
                              </Typography>
                              <Typography sx={{ ...commonTypographyStyles, color: "#d18b1f", fontWeight: 600 }}>
                                {userDetails.platformemail}
                              </Typography>
                            </Box>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Suborder Id :-  <strong style={highlightedText}>{order.id.subOrderNumber}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Order Date :-  <strong style={highlightedText}>{updateExpectedDeliveryDateNumberFormat(order.id.orderDate)}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              SKU :-  <strong style={highlightedText}>{order.sku}</strong>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Settlement Value :-  <strong style={highlightedText}>{order.meeshoPayments.length > 0 ? order.meeshoPayments?.reduce((total, payment) => total + (payment.finalSettlementAmount || 0), 0) : 0}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Status :-
                              <Chip label={order.finalStatus} size="small" color="primary" style={{ height: '20px', marginLeft: "10px" }} sx={{
                                height: '20px',
                                '& .MuiChip-label': {
                                  fontSize: '11px',
                                  color: 'white',
                                  padding: "5px"
                                }
                              }} />
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              {/* -------------------- */}
                              Scanning Status :-  <strong style={highlightedText}>{ }</strong>
                            </Typography><Typography variant="body2" sx={commonTypographyStyles}>
                              {/* ----------------------- */}
                              Forward Awb No. :-  <strong style={highlightedText}>{ }</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              {/* ----------------------- */}
                              Return Awb No. :-  <strong style={highlightedText}>{order.awbNumber}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Packet Qr :-  <strong style={highlightedText}>{order.packetId}</strong>
                            </Typography>

                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={4} sx={{
                            ...(subOrederList.length && {
                              borderTop: {
                                xs: '1px solid #ccc', // No border on extra small screens
                                lg: 'none', // Border on large screens and above
                              },
                            }),
                          }}>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              <strong style={{ letterSpacing: "0.5px", marginLeft: "2px", fontSize: "inherit", color: "#7367f0" }}>Return Details</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Dispatch Date :-   <strong style={highlightedText}>{updateExpectedDeliveryDateNumberFormat(order.dispatchDate)}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Return Created Date :-  <strong style={highlightedText}>{updateExpectedDeliveryDateNumberFormat(order.returnCreatedAt)}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Expected Delivery Date :-  <strong style={highlightedText}>{updateExpectedDeliveryDateNumberFormat(order.expectedDeliveryDate)}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Delivered Date :-  <strong style={highlightedText}>{updateExpectedDeliveryDateNumberFormat(order.deliveredDate)}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Courier Partner :-  <strong style={highlightedText}>{order.courierPartner}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Type Of Return :- <strong style={highlightedText}>{order.typeOfReturn}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              OTP verified :-  <strong style={highlightedText}>{order.otpVerifiedAt ? " Yes" : ' No'}</strong>
                            </Typography>
                          </Grid>
                          {order.meeshoPayments.length > 0 && <Grid item xs={12} sm={6} md={6} lg={4} sx={{
                            ...(subOrederList.length && {
                              borderTop: '1px solid #ccc', // Border on large screens and above
                            }),
                          }}>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              <strong style={{ letterSpacing: "0.5px", marginLeft: "2px", fontSize: "inherit", color: "#7367f0" }}>Payment Details</strong>
                            </Typography>
                            {order.meeshoPayments.map((claim, idx) => (
                              <>
                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  transactionId :-  <strong style={highlightedText}>{claim.transactionId}</strong>
                                </Typography>
                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  Date :-   <strong style={highlightedText}>{updateExpectedDeliveryDateNumberFormat(claim.paymentDate)}</strong>
                                </Typography>
                                {order.meeshoPayments.length > 0 ? <Typography variant="body2" sx={commonTypographyStyles}>
                                  Amount :-   <strong style={highlightedText}>{claim.finalSettlementAmount}</strong>
                                </Typography> : <></>}

                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  Recovery  :-  <strong style={highlightedText}>{claim.recovery}</strong>
                                </Typography>
                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  Shipping  :-  <strong style={highlightedText}>{claim.liveOrderStatus}</strong>
                                </Typography>
                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  Shipping Gst :-  <strong style={highlightedText}>{claim.liveOrderStatus}</strong>
                                </Typography>
                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  Tcs :-  <strong style={highlightedText}>{claim.tcs}</strong>
                                </Typography>
                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  Tds  :-  <strong style={highlightedText}>{claim.tds}</strong>
                                </Typography>
                                <Typography variant="body2" sx={commonTypographyStyles}>
                                  Status :-  <strong style={highlightedText}>{claim.liveOrderStatus}</strong>
                                </Typography>
                                {idx !== order.meeshoPayments.length - 1 && (
                                  <Divider sx={{ my: 1, borderColor: "#ccc" }} />
                                )}
                              </>
                            ))}
                          </Grid>}
                          {/* {order.trueClaims.length > 0 && <Grid item xs={12} sm={6} md={6} lg={4} sx={{
                            ...(subOrederList.length && {
                              borderTop: '1px solid #ccc', // Border on large screens and above

                            }),
                          }}>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              <strong style={{ letterSpacing: "0.5px", marginLeft: "2px", fontSize: "inherit", color: "#7367f0" }}>Claim Details</strong>
                            </Typography>
                            {order.trueClaims.length > 0 ? <Typography variant="body2" sx={commonTypographyStyles}>
                              Claim Ticket ID : <strong style={highlightedText}>{order.trueClaims[0].ticketId}</strong>
                            </Typography> : ''}
                            {order.trueClaims.length > 0 ? <Typography variant="body2" sx={commonTypographyStyles}>
                              Claim Retries : <strong style={highlightedText}>{order.trueClaims[0].retries}</strong>
                            </Typography> : ''}
                            {order.trueClaims.length > 0 ? <Typography variant="body2" sx={commonTypographyStyles}>
                              Claim Ticket Generate Date : <strong style={highlightedText}>{isoToSortDate(order.trueClaims[0].updatedAt)}</strong>
                            </Typography> : ''}
                          </Grid>} */}
                          {order.trueClaims.length > 0 && (
                            <Grid item xs={12} sm={6} md={6} lg={4} sx={{
                              ...(subOrederList.length && {
                                borderTop: '1px solid #ccc',
                              }),
                            }}>
                              <Typography variant="body2" sx={commonTypographyStyles}>
                                <strong style={{
                                  letterSpacing: "0.5px",
                                  marginLeft: "2px",
                                  fontSize: "inherit",
                                  color: "#7367f0"
                                }}>Claim Details</strong>
                              </Typography>

                              {order.trueClaims.map((claim, idx) => (
                                <Box key={idx} sx={{ mb: 1 }}>
                                  <Typography variant="body2" sx={commonTypographyStyles}>
                                    Claim Ticket ID : <strong style={highlightedText}>{claim.ticketId}</strong>
                                  </Typography>
                                  {/* <Typography variant="body2" sx={commonTypographyStyles}>
                                    Claim Retries : <strong style={highlightedText}>{claim.retries}</strong>
                                  </Typography> */}
                                  <Typography variant="body2" sx={commonTypographyStyles}>
                                    Claim Ticket Generate Date : <strong style={highlightedText}>{isoToSortDate(claim.updatedAt)}</strong>
                                  </Typography>
                                  {idx !== order.trueClaims.length - 1 && (
                                    <Divider sx={{ my: 1, borderColor: "#ccc" }} />
                                  )}
                                </Box>
                              ))}
                            </Grid>
                          )}
                          {order.smartClaims.length > 0 && <Grid item xs={12} sm={6} md={6} lg={4} sx={{
                            ...(subOrederList.length && {
                              borderTop: '1px solid #ccc', // Border on large screens and above

                            }),
                          }}>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              <strong style={{ letterSpacing: "0.5px", marginLeft: "2px", fontSize: "inherit", color: "#7367f0" }}>Smart Claim Details</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              AWB Number :-  <strong style={highlightedText}>{order.smartClaims[0].awbNumber}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              ticket Id :-  <strong style={highlightedText}>{order.smartClaims[0].ticketId}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Packet ID :-  <strong style={highlightedText}>{order.smartClaims[0].packetId}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Type Of Claim :-  <strong style={highlightedText}>{order.smartClaims[0].typeOfClaim}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              returnTypes :-  <strong style={highlightedText}>{order.smartClaims[0].returnTypes}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              statusOfClaim :-  <strong style={highlightedText}>{order.smartClaims[0].statusOfClaim}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              State Of Packet :-  <strong style={highlightedText}>{order.smartClaims[0].stateOfPacket}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Created Date :-  <strong style={highlightedText}>{formatDate(order.smartClaims[0].createdDate)}</strong>
                            </Typography>
                            <Typography variant="body2" sx={commonTypographyStyles}>
                              Updated Date :-  <strong style={highlightedText}>{order.smartClaims[0].updatedDate ? formatDate(order.smartClaims[0].updatedDate) : ' NO '}</strong>
                            </Typography>
                          </Grid>}
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            {order.smartClaims.length > 0 && !order.smartClaims[0].ticketId ? <TextField
                              size="small"
                              defaultValue={ticket} // Use ref for performance
                              placeholder="Ticket Id"
                              onChange={(e) => setTicket(e.target.value)}
                              variant="outlined"
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  handleSubmitRequest(order.smartClaims[0], index)
                                }
                              }}
                              sx={{ "& .MuiOutlinedInput-root": { height: "35px", fontSize: "12px" } }}
                            /> : <></>}
                            <Button variant='contained' disabled={isLoading} style={{ marginRight: "10px", fontSize: '12px', padding: "10px 15px" }} onClick={() => handleSubmitRequest(order.smartClaims[0], index)}>
                              {"Submit"}
                            </Button>
                            <Button variant='contained' disabled={isLoading} color='error' style={{ marginRight: "10px", padding: "10px 15px", fontSize: '12px' }} onClick={() => handleFailRequest(order.smartClaims[0], index)}>{"Failed"}</Button>
                            <Button variant='contained' color='warning' style={{ marginRight: "10px", fontSize: '12px', padding: "10px 15px" }} onClick={() => handleAutoFill(order)}>
                              Autofill
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>)
                    })}
                  </Grid>
                </Box>
              </Box>) : null
            }
          </Dialog >
        )}
      </Box >
    )
  }
}

export default AutocompleteComponent
